/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { Pageable } from '../model/pageable';
// @ts-ignore
import { PagedModelServizioMensaAnagraficaRowDTO } from '../model/paged-model-servizio-mensa-anagrafica-row-dto';
// @ts-ignore
import { ServizioMensaAnagraficheListFilter } from '../model/servizio-mensa-anagrafiche-list-filter';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    ServizioMensaAnagraficheServiceInterface,
    ListServizioMensaAnagraficheRequestParams
} from './servizio-mensa-anagrafiche.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class ServizioMensaAnagraficheService extends BaseService implements ServizioMensaAnagraficheServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Lista dei richiedenti del servizio mensa.
     * Pagina di righe flat (identità genitore, riferimento Pratica, conteggio studenti attivi) dei richiedenti del servizio header-tenant. Default solo Pratiche accettate; include_non_accettate&#x3D;true include anche le altre. Filtri nominativo/email/codice_fiscale a match esatto (identità cifrata). scuola_id/classe/sezione tengono il genitore se ha almeno un figlio (sospesi compresi) con quei valori; una scuola di un altro servizio da\&#39; una lista vuota. Ogni riga riporta le iscrizioni dei figli (scuola, classe, sezione, sospeso, senza dati del minore) e se il genitore ha cancellato l\&#39;account.
     * @endpoint get /api/v1/servizi/mensa/anagrafiche
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public listServizioMensaAnagrafiche(requestParameters: ListServizioMensaAnagraficheRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PagedModelServizioMensaAnagraficaRowDTO>;
    public listServizioMensaAnagrafiche(requestParameters: ListServizioMensaAnagraficheRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PagedModelServizioMensaAnagraficaRowDTO>>;
    public listServizioMensaAnagrafiche(requestParameters: ListServizioMensaAnagraficheRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PagedModelServizioMensaAnagraficaRowDTO>>;
    public listServizioMensaAnagrafiche(requestParameters: ListServizioMensaAnagraficheRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const filter = requestParameters?.filter;
        if (filter === null || filter === undefined) {
            throw new Error('Required parameter filter was null or undefined when calling listServizioMensaAnagrafiche.');
        }
        const pageable = requestParameters?.pageable;
        if (pageable === null || pageable === undefined) {
            throw new Error('Required parameter pageable was null or undefined when calling listServizioMensaAnagrafiche.');
        }
        const gestioneMenseServizioId = requestParameters?.gestioneMenseServizioId;
        if (gestioneMenseServizioId === null || gestioneMenseServizioId === undefined) {
            throw new Error('Required parameter gestioneMenseServizioId was null or undefined when calling listServizioMensaAnagrafiche.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'filter',
            <any>filter,
            QueryParamStyle.Form,
            true,
        );


        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'pageable',
            <any>pageable,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;
        if (gestioneMenseServizioId !== undefined && gestioneMenseServizioId !== null) {
            localVarHeaders = localVarHeaders.set('Gestione-Mense-Servizio-Id', String(gestioneMenseServizioId));
        }

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/servizi/mensa/anagrafiche`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PagedModelServizioMensaAnagraficaRowDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
